import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../../../hooks/customDocumentTitleHook";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeDate, getPractice, usPhoneFormat } from "../../../../helpers";
import { fetchSIngleDotPhysicalForm } from "../../../../services/forms";

const customStyles = {
  page: {
    background: 'white',
    display: 'block',
    margin: '0 auto',
  },
  A4: {
    width: '21cm',
    height: '29.6cm'
  },
  headingTextSmall: {
    fontSize: '10.5px',
    fontWeight: 'normal'
  },
  headingFirst: {
    marginLeft: '40px',
    padding: '5px',
    border: '1px solid var(--border)'
  },
  headingSecond: {
    marginTop: '-35px',
    position: 'relative',
    padding: '5px',
    border: '1px solid var(--border)',
    borderTop: 0
  },
  reportingBox: {
    width: '40px',
    borderTop: '1px solid  var(--border)',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  customInput: {
    fontSize: '.9rem',
    padding: '0',
    border: 'none',
    borderBottom: '0.7px solid var(--border)',
    borderRadius: '0',
    background: 'transparent',
    margin: '0 3px -2px 3px',
    outline: '0'
  },
  infoDiv: {
    border: '1px solid rgb(49 85 164)',
  },
  successDiv: {
    border: '1px solid rgb(0 124 62)',
  },
  headingReport: {
    textAlign: 'center',
    border: '1px solid #cc1818',
    padding: '5px 10px',
  },
  pageInfo: {
    border: '1px solid #cc1818',
    padding: '2px 7px',
    marginBottom: '10px',
  }
};

export default function DotPhysicalPrint({ ...props }) {
  const {    
    formViewId,
    formViewSize = "A4",
    setFormView = () => {}
  } = props;

  const [formData, setFormData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const navigate = useNavigate();
  const contentRef = useRef();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accountId = getPractice("account_id");
  const locationId = getPractice("location_id");

  let formId = formViewId;
  let formSize = formViewSize;
  if (queryParams.get('form_id')) {
    formId = queryParams.get('form_id');
    formSize = queryParams.get('size');
  } 

  useEffect(() => {
    if(formId !== null){
      getReferralData( formId );
    } else {
      navigate(-1);
    }
  }, [formId]);

  const getReferralData = async ( formId ) => {
    const response = await fetchSIngleDotPhysicalForm( accountId, locationId, formId );
    if (response) {
      if(response.data === null) {
        window.close();
      }
      setFormData(response?.data);
      setIsDataLoaded(true);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  // useEffect(() => {
  //   if (isDataLoaded && queryParams.get('form_id')) {
  //     handlePrint();
  //   }
  // }, [isDataLoaded, queryParams]);

  const handleCloseWindow = () => {
    window.close();
  };

  const handleFormPrint = (formId) => {
    setFormView();
    const url = `/forms/dot-physical-form/print?form_id=${formId}&size=A4`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const pageSize = formSize == "A4" ? "A4" : "Letter";
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media print {
        @page {
          size: ${pageSize};
        }
      }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [formSize]);

  const pageClass = formSize === "A4" ? "print-page-a4" : "print-page-letter";
  useDocumentTitle("DOT Physical Form");

  return (
    <div ref={contentRef} className="docpro_signout_wrap">
      <div className="docpro_signout">
        <div style={{ fontFamily: 'sans-serif' }}>
          <div style={{ ...customStyles.page }}>
            <div className="page mt-1">
              <div style={customStyles.headingFirst}>
                <p className="fw-bold mb-0" style={{ fontSize: '12px' }}>Public Burden Statement</p>
                <p className="mb-0" style={{ lineHeight: '13.4px' }}>
                  <small style={ customStyles.headingTextSmall }>
                    A Federal agency may not conduct or sponsor, and a person is not required to respond to, nor shall a person be subject to a penalty for failure to comply with a collection of information subject to the requirements of
                    the Paperwork Reduction Act unless that collection of information displays a current valid OMB Control Number. The OMB Control Number for this information collection is 2126-0006. Public reporting for this collection
                    of information is estimated to be approximately 25 minutes per response, including the time for reviewing instructions, gathering the data needed, and completing and reviewing the collection of information. All
                    responses to this collection of information are mandatory. Send comments regarding this burden estimate or any other aspect of this collection of information, including suggestions for reducing this burden to:
                    Information Collection Clearance Officer, Federal Motor Carrier Safety Administration, MC-RRA, 1200 New Jersey Avenue, SE, Washington, D.C. 20590.
                  </small>
                </p>
              </div>
              <div style={customStyles.headingSecond}>
                <div>
                  <img src="https://demo.doc.pro/uploads/form/fmcsa_icon.png" alt="fmcsa icon" style={{ height: '30px' }} />
                  <p className="mb-0 mt-1" style={{ fontSize: '12.5px', lineHeight: '14px' }}>U.S. Department of Transportation</p>
                  <p className="mb-0" style={{ fontSize: '12.5px', lineHeight: '14px' }}>Federal Motor Carrier</p>
                  <p className="mb-0" style={{ fontSize: '12.5px', lineHeight: '14px' }}>Safety Administration</p>
                </div>
                <div style={{ marginTop: '-30px' }}>
                  <h5 className="mb-0 text-center">Medical Examination Report Form</h5>
                  <p className="mb-0 fw-bold text-center" style={{ fontSize: '.75em', lineHeight: '10px' }}>(for Commercial Driver Medical Certification)</p>
                </div>
                <div style={customStyles.reportingBox}></div>
              </div>
              <div className="flex py-2" style={{ alignItems: 'end', justifyContent: 'space-between' }}>
                <p className="dot_phy_semi_paragraph"><b>SECTION 1. Driver Information</b> <small style={{ fontSize: '90%' }}><i>(to be filled out by the driver)</i></small></p>
                <div style={customStyles.headingReport}>
                  <h6 className="mb-1 docpro_fs_16">MEDICAL RECORD #</h6>
                  <input type="text" defaultValue={formData?.medical_r_no} style={{ ...customStyles.customInput, textAlign: "center", width: '100%' }} readOnly></input>
                  <p className="dot_phy_semi_paragraph">(or sticker)</p>
                </div>
              </div>
              <div style={customStyles.infoDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(49 85 164)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>PERSONAL INFORMATION</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="dot_phy_paragraph">
                    Last Name: <input type="text" defaultValue={formData?.info_last_name} style={customStyles.customInput} required readOnly></input>
                    First Name: <input type="text" defaultValue={formData?.info_first_name} style={customStyles.customInput} required readOnly></input>
                    Middle Initial: <input type="text" defaultValue={formData?.info_middle_name} style={{ ...customStyles.customInput, width: '62px' }} readOnly></input>
                    Date of Birth: <input type="text" defaultValue={exchangeDate(formData?.info_dob)} style={{ ...customStyles.customInput, width: '100px' }} minLength="10" maxLength="10" required readOnly></input>
                    Age: <input type="text" defaultValue={formData?.info_age} style={{ ...customStyles.customInput, width: '40px' }} readOnly></input>
                    Street Address: <input type="text" defaultValue={formData?.info_address} name="info_address" style={{ ...customStyles?.customInput, width: '230px' }} readOnly></input>
                    City: <input type="text" defaultValue={formData?.info_city} style={{ ...customStyles.customInput, width: '100px' }} readOnly></input>
                    State/Province: 
                    <select value={formData?.info_state} style={{ ...customStyles.customInput, width: '62px' }} disabled>
                      <option value="AK">AK</option>
                      <option value="AL">AL</option>
                      <option value="AR">AR</option>
                      <option value="AZ">AZ</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DC">DC</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="IA">IA</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="MA">MA</option>
                      <option value="ME">ME</option>
                      <option value="MI">MI</option>
                      <option value="MO">MO</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="NE">NE</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NV">NV</option>
                      <option value="NY">NY</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VA">VA</option>
                      <option value="VT">VT</option>
                      <option value="WA">WA</option>
                      <option value="WI">WI</option>
                      <option value="WV">WV</option>
                      <option value="WY">WY</option>
                      <option value="AB">AB</option>
                      <option value="BC">BC</option>
                      <option value="MB">MB</option>
                      <option value="NB">NB</option>
                      <option value="NL">NL</option>
                      <option value="NS">NS</option>
                      <option value="NT">NT</option>
                      <option value="NU">NU</option>
                      <option value="ON">ON</option>
                      <option value="PE">PE</option>
                      <option value="QC">QC</option>
                      <option value="SK">SK</option>
                      <option value="YT">YT</option>
                    </select>
                    Zip Code: <input type="text" defaultValue={formData?.info_zip} style={{ ...customStyles.customInput, width: '100px' }} readOnly></input>
                    Driver’s License No: <input type="text" defaultValue={formData?.info_li_num} style={customStyles.customInput} readOnly></input>
                    Issuing State/ Province: 
                    <select value={formData?.info_issue_state} style={{ ...customStyles.customInput, width: '85px' }} disabled>
                      <option value="1">Alberta</option>
                      <option value="2">Alabama</option>
                      <option value="3">Alaska</option>
                      <option value="4">Arizona</option>
                      <option value="5">ARkansas</option>
                      <option value="6">California</option>
                      <option value="7">Colorado</option>
                      <option value="8">Connecticut</option>
                      <option value="9">Delaward</option>
                      <option value="10">District of Columbia</option>
                      <option value="11">Florida</option>
                      <option value="12">Georgia</option>
                      <option value="13">Hawaii</option>
                      <option value="14">Idaho</option>
                      <option value="15">Illinois</option>
                      <option value="16">Indiana</option>
                      <option value="17">Lowa</option>
                      <option value="18">Kansas</option>
                      <option value="19">Kentucky</option>
                      <option value="20">Louisiana</option>
                      <option value="21">Maine</option>
                      <option value="22">Maryland</option>
                      <option value="23">Massachusetts</option>
                      <option value="24">Machigan</option>
                      <option value="25">Minnesota</option>
                      <option value="26">Mississippi</option>
                      <option value="27">Missouri</option>
                      <option value="28">Montana</option>
                      <option value="29">Nebraska</option>
                      <option value="30">Nevada</option>
                      <option value="31">New Hampshire</option>
                      <option value="32">New Jersy</option>
                      <option value="33">New Maxico</option>
                      <option value="34">New York</option>
                      <option value="35">North Carolina</option>
                      <option value="36">North Dakota</option>
                      <option value="37">Ohio</option>
                      <option value="38">Oklahoma</option>
                      <option value="39">Oregon</option>
                      <option value="40">Pennsylvania</option>
                      <option value="41">Rhode Island</option>
                      <option value="42">South Carolina</option>
                      <option value="43">South Dakota</option>
                      <option value="44">Tennessee</option>
                      <option value="45">Texas</option>
                      <option value="46">Utah</option>
                      <option value="47">Vermont</option>
                      <option value="48">Virginia</option>
                      <option value="49">Washington</option>
                      <option value="50">West Virginia</option>
                      <option value="51">Wisconsin</option>
                      <option value="52">Wyoming</option>
                      <option value="53">British Calumbia</option>
                      <option value="54">Manitoba</option>
                      <option value="55">New Brunswick</option>
                      <option value="56">Newfoundland and Labrador</option>
                      <option value="57">Northwest Territories</option>
                      <option value="58">Nova Scotia</option>
                      <option value="59">Nunavut</option>
                      <option value="60">Ontaria</option>
                      <option value="61">Prince Edward Island</option>
                      <option value="62">Quebec</option>
                      <option value="63">Saskatchewan</option>
                      <option value="64">Yukon</option>
                    </select>
                    Phone: <input type="text" defaultValue={usPhoneFormat(formData?.info_phone)} style={customStyles.customInput} minLength="10" maxLength="10" readOnly></input>
                    E-Mail <small><i>(optional)</i></small>: <input type="email" defaultValue={formData?.info_email} style={{ ...customStyles.customInput, width: '250px' }}></input>
                    CLP/CDL Applicant/Holder <small className="mr-2 docpro_red_color">* :</small> 
                    <span className="inline-flex items-center">
                      <input type="radio" name="info_cpl_holder" checked={formData?.info_cpl_holder == 1} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                      <input type="radio" name="info_cpl_holder" checked={formData?.info_cpl_holder == 2} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                    </span>
                  </p>
                  <p className="dot_phy_paragraph" style={{textAlign: 'right', marginTop: '5px', marginBottom: '6px'}}>
                    Driver ID Verified By <small className="docpro_red_color">**</small>: <input type="text" defaultValue={formData?.info_verify_by} style={customStyles.customInput} readOnly></input>
                  </p>
                  <p className="mb-0" style={{fontSize: ".9rem", lineHeight: "1.9em"}}>
                    Has your USDOT/FMCSA medical certificate ever been denied or issued for less than 2 years?
                    <span className="inline-flex items-center pl-2">
                      <input type="radio" checked={formData?.info_issue_time == 1} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                      <input type="radio" checked={formData?.info_issue_time == 3} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                      <input type="radio" checked={formData?.info_issue_time == 2} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Not Sure</span>
                    </span>
                  </p>
                </div>
              </div>

              <div className="driver-footer mb-1">
                <small className="mb-0"><span className="docpro_red_color mr-1">*</span>CLP/CDL Applicant/Holder: See instructions for definitions</small> <br/>
                <small><span className="docpro_red_color mr-1">**</span>Driver ID Verified By: Record what type of photo ID was used to verify the identity of the driver, e.g., CDL, driver’s license, passport</small>
              </div>

              <div style={customStyles.infoDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(49 85 164)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>DRIVER HEALTH HISTORY</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="flex justify-between dot_phy_paragraph">
                    Have you ever had surgery? If “yes,” please list and explain below
                    <span className="inline-flex items-center pl-2">
                      <input type="radio" checked={formData?.have_surgery == 1} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                      <input type="radio" checked={formData?.have_surgery == 3} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                      <input type="radio" checked={formData?.have_surgery == 2} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Not Sure</span>
                    </span>
                  </p>
                  <textarea className="dot_physical w-full p-2" rows={formSize == 'A4' ? 6 : 5} readOnly defaultValue={formData?.have_surgery_reason}></textarea>

                  <p className="dot_phy_paragraph">
                    <span>Are you currently taking medications <small style={{ fontSize: '90%' }}><i>(prescription, over-the-counter, herbal remedies, diet supplements)</i></small>?</span>
                    <span style={{justifyContent: 'end'}} className="flex items-center pl-2">
                      <input type="radio" checked={formData?.current_medicine == 1} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                      <input type="radio" checked={formData?.current_medicine == 3} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                      <input type="radio" checked={formData?.current_medicine == 2} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Not Sure</span>
                    </span>
                  </p>
                  <p className="dot_phy_paragraph" style={{marginTop: '-5px'}}>If “yes,” please describe below.</p>
                  <textarea className="dot_physical w-full p-2" rows={formSize == 'A4' ? 5 : 4} readOnly defaultValue={formData?.medication_reason}></textarea>
                </div>
              </div>
              <p className="dot_phy_paragraph" style={{textAlign: 'end'}}><i>(Attach additional sheets if necessary)</i></p>
              <div style={{ minHeight: '35px' }}>
                {formData?.drive_health_sheets != null &&
                 <>
                  <p style={{fontSize: ".93rem", lineHeight: "1.3em", marginBottom: '5px'}}> Sheet: 
                    <span className="pl-2" style={{ color: '#3155a4' }}>{formData?.drive_health_sheets}</span>
                  </p>
                 </>
                }
              </div>
              <p className="mb-0" style={{fontSize: ".93rem", lineHeight: "1.3em"}}>**This document contains sensitive information and is for official use only. Improper handling of this information could negatively affect individuals. Handle and secure this information appropriately to prevent inadvertent disclosure by keeping the documents under the control of authorized persons. Properly dispose of this document when no longer required to be maintained by regulatory requirements.**</p>

              <div className="page_divider"></div>

              <div style={ customStyles.pageInfo }>
                <p className="dot_phy_paragraph">
                  Last Name: <input type="text" defaultValue={formData?.info_last_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  First Name: <input type="text" defaultValue={formData?.info_first_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  DOB: <input type="text" defaultValue={exchangeDate(formData?.info_dob)} readOnly style={{ ...customStyles.customInput, width: '95px' }}></input>
                  Exam Date: <input type="text" defaultValue={exchangeDate(formData?.heading_exam_date_1)} style={{ ...customStyles.customInput, width: '95px' }} readOnly></input>
                </p>
              </div>

              <div style={customStyles.infoDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(49 85 164)", padding: "5px 8px", color: "#ffffff"}}><b style={{ color: "#ffffff" }}>DRIVER HEALTH HISTORY </b><i>(continued)</i></p>
                <div style={{ padding: '8px' }}>
                  <table className={`history-table mb-0 ${pageClass}`}>
                    <thead>
                      <tr>
                        <td><p><b>Do you have or have you ever had:</b></p></td>
                        <td><p className="text-center"><b>Yes</b></p></td>
                        <td><p className="text-center"><b>No</b></p></td>
                        <td><p className="text-center"><b>Not Sure</b></p></td>
                        <td></td>
                        <td><p className="text-center"><b>Yes</b></p></td>
                        <td><p className="text-center"><b>No</b></p></td>
                        <td><p className="text-center"><b>Not Sure</b></p></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><p className="flex"><span className="mr-1">1.</span> <span>Head/brain injuries or illnesses <small><i>(e.g., concussion)</i></small></span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_1 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_1 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_1 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">17.</span> <span>Unexplained weight loss</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_17 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_17 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_17 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">2.</span> <span>Seizures/epilepsy</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_2 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_2 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_2 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">18.</span> <span>Stroke, mini-stroke (TIA), paralysis, or weakness</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_18 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_18 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_18 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">3.</span> <span>Eye problems <small><i>(except glasses or contacts)</i></small></span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_3 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_3 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_3 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">19.</span> <span>Missing or limited use of arm, hand, finger, leg, foot, toe</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_19 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_19 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_19 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">4.</span> <span>Ear and/or hearing problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_4 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_4 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_4 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">20.</span> <span>Neck or back problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_20 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_20 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_20 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">5.</span> <span>Heart disease, heart attack, bypass, or other heart problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_5 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_5 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_5 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">21.</span> <span>Bone, muscle, joint, or nerve problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_21 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_21 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_21 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">6.</span> <span>Pacemaker, stents, implantable devices, or other heart procedures</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_6 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_6 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_6 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">22.</span> <span>Blood clots or bleeding problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_22 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_22 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_22 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">7.</span> <span>High blood pressure</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_7 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_7 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_7 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">23.</span> <span>Cancer</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_23 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_23 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_23 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">8.</span> <span>High cholesterol</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_8 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_8 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_8 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">24.</span> <span>Chronic (long-term) infection or other chronic diseases</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_24 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_24 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_24 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">9.</span> <span>Chronic (long-term) cough, shortness of breath, or other breathing problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_9 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_9 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_9 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">25.</span> <span>Sleep disorders, pauses in breathing while asleep, daytime sleepiness, loud snoring</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_25 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_25 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_25 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">10.</span> <span>Lung disease <small><i>(e.g., asthma)</i></small></span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_10 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_10 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_10 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">26.</span> <span>Have you ever had a sleep test <small><i>(e.g., sleep apnea)</i></small>?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_26 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_26 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_26 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">11.</span> <span>Kidney problems, kidney stones, or pain/problems with urination</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_11 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_11 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_11 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">27.</span> <span>Have you ever spent a night in the hospital?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_27 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_27 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_27 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">12.</span> <span>Stomach, liver, or digestive problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_12 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_12 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_12 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">28.</span> <span>Have you ever had a broken bone?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_28 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_28 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_28 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">13.</span> <span>Diabetes or blood sugar problems Insulin used</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_13 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_13 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_13 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">29.</span> <span>Have you ever used or do you now use tobacco?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_29 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_29 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_29 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">14.</span> <span>Diabetes or blood sugar problems Insulin used</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_14 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_14 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_14 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">30.</span> <span>Do you currently drink alcohol?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_30 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_30 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_30 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">15.</span> <span>Fainting or passing out</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_15 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_15 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_15 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">31.</span> <span>Have you used an illegal substance within the past two years?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_31 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_31 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_31 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">16.</span> <span>Anxiety, depression, nervousness, other mental health problems</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_16 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_16 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_16 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">32.</span> <span>Have you ever failed a drug test or been dependent on an illegal substance?</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_32 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_32 == 3} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.history_32 == 2} /></p></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="mt-2">
                <p className="flex justify-between" style={{fontSize: ".93rem", lineHeight: "1.3em", marginBottom: '4px'}}>
                  Other health condition(s) not described above
                  <span className="inline-flex items-center pl-2">
                    <input type="radio" checked={formData?.other_health == 1} disabled></input>
                    <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                    <input type="radio" checked={formData?.other_health == 3} disabled></input>
                    <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                    <input type="radio" checked={formData?.other_health == 2} disabled></input>
                    <span className="px-2" style={{ lineHeight: '15px' }}>Not Sure</span>
                  </span>
                </p>
                <textarea className="dot_physical w-full p-2" rows="5" readOnly defaultValue={formData?.other_health_reason}></textarea>

                <p className="flex justify-between" style={{fontSize: ".93rem", lineHeight: "1.3em", marginBottom: '7px' }}>
                  Did you answer “yes” to any of questions 1-32?
                  <span className="inline-flex items-center pl-2">
                    <input type="radio" checked={formData?.further_reason == 1} disabled></input>
                    <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                    <input type="radio" checked={formData?.further_reason == 3} disabled></input>
                    <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                    <input type="radio" checked={formData?.further_reason == 2} disabled></input>
                    <span className="px-2" style={{ lineHeight: '15px' }}>Not Sure</span>
                  </span>
                </p>
                <p style={{fontSize: ".93rem", lineHeight: "1.3em", marginBottom: '4px', marginTop: '-5px' }}>If so, please comment further on those health conditions below:</p>
                <textarea className="dot_physical w-full p-2" rows="5" readOnly defaultValue={formData?.further_reason_details}></textarea>
              </div>
              <p className="dot_phy_paragraph" style={{textAlign: 'end'}}><i>(Attach additional sheets if necessary)</i></p>
              <div style={{ minHeight: formSize == 'A4' ? '45px' : '0' }}>
                {formData?.health_history_sheet != null &&
                 <>
                  <p style={{fontSize: ".93rem", lineHeight: "1.3em", marginBottom: '5px'}}> Sheet: 
                    <span className="pl-2" style={{ color: '#3155a4' }}>{formData?.health_history_sheet}</span>
                  </p>
                 </>
                }
              </div>
              
              <div className="page_divider"></div>

              <div style={ customStyles.pageInfo }>
                <p className="dot_phy_paragraph">
                  Last Name: <input type="text" defaultValue={formData?.info_last_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  First Name: <input type="text" defaultValue={formData?.info_first_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  DOB: <input type="text" defaultValue={exchangeDate(formData?.info_dob)} readOnly style={{ ...customStyles.customInput, width: '95px' }}></input>
                  Exam Date: <input type="text" defaultValue={exchangeDate(formData?.heading_exam_date_1)} style={{ ...customStyles.customInput, width: '95px' }} readOnly></input>
                </p>
              </div>
              <div style={customStyles.infoDiv}>
                <p  className="dot_phy_semi_paragraph" style={{background: "rgb(49 85 164)", padding: "5px 8px", color: "#ffffff"}}><b style={{ color: "#ffffff" }}>CMV DRIVER’S SIGNATURE</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="dot_phy_semi_paragraph" style={{marginBottom: '10px'}}>
                    I certify that the above information is accurate and complete. I understand that inaccurate, false or missing information may invalidate the examination
                    and my Medical Examiner’s Certificate, that submission of fraudulent or intentionally false information is a violation of <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.390#se49.5.390_135" className="docpro_sky_color">49 CFR 390.35</a>, and that submission
                    of fraudulent or intentionally false information may subject me to civil or criminal penalties under <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.390#se49.5.390_137" className="docpro_sky_color">49 CFR 390.37</a> and <a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=15ff246ad2c354d3d592b19a9b3f7344&mc=true&node=sp49.5.386.g&rgn=div6" className="docpro_sky_color">49 CFR 386</a> Appendices A and B.
                  </p>
                  <p className="dot_phy_paragraph">
                    Driver’s Signature: <span className="input-text">{formData?.driver_signature}</span>
                    Date: <span className="input-text">{exchangeDate(formData?.driver_signature_date)}</span>
                  </p>
                </div>
              </div>

              <div style={{ borderTop: '2px solid rgb(0 124 62)', margin: '8px 0' }}></div>
              <p className="dot_phy_semi_paragraph"><b>SECTION 2. Examination Report</b> <small style={{ fontSize: '90%' }}><i>(to be filled out by the medical examiner)</i></small></p>

              <div className="mb-2" style={customStyles.successDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(0 124 62)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>DRIVER HEALTH HISTORY REVIEW</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="mb-1" style={{lineHeight: '14px'}}>
                    <small style={{ fontSize: '90%' }}><i>Review and discuss pertinent driver answers and any available medical records. Comment on the driver’s responses to the “health history” questions that may affect the
                    driver’s safe operation of a commercial motor vehicle (CMV).</i></small>
                  </p>
                  <textarea className="dot_physical w-full p-2" rows={formSize == 'A4' ? 4 : 3} readOnly defaultValue={formData?.health_history_review}></textarea>
                  {formSize == 'A4' &&
                    <p className="dot_phy_paragraph" style={{textAlign: 'end'}}><i>(Attach additional sheets if necessary)</i></p>
                  }
                </div>
              </div>

              <div style={customStyles.successDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(0 124 62)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>TESTING</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="flex dot_phy_paragraph">
                    Pulse Rate: <span className="input-text" style={{ minWidth: '80px' }}>{formData?.test_pulse_rate}</span>
                    Pulse rhythm regular:
                    <span className="inline-flex items-center pl-2">
                      <input type="radio" checked={formData?.test_pulse_regular == 1} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>Yes</span>
                      <input type="radio" checked={formData?.test_pulse_regular == 3} disabled></input>
                      <span className="px-2" style={{ lineHeight: '15px' }}>No</span>
                    </span>
                    Height: <span className="input-text" style={{ minWidth: '40px' }}>{formData?.test_feet}</span> <small><i>feet</i></small>
                    <span className="input-text" style={{ minWidth: '40px' }}>{formData?.test_inch}</span> <small className="mr-1"><i>inches</i></small>
                    Weight: <span className="input-text" style={{ minWidth: '40px' }}>{formData?.test_weight}</span> <small><i>pounds</i></small>
                  </p>
                  <div style={{ borderTop: '2px solid rgb(0 124 62)', margin: '8px 0' }}></div>
                  <div className="flex">
                    <div className="docpro_table_1 hipaa_table mr-2" style={{ boxShadow: 'none', borderRadius: 0, width: '40%' }}>
                      <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph" style={{whiteSpace: 'nowrap'}}><b style={{ color: "rgb(0 124 62)" }}>Blood Pressure</b></p></td>
                            <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Systolic</p></td>
                            <td style={{ padding: '5px' }}><p className="dot_phy_sm_paragraph">Diastolic</p></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Sitting</p></td>
                            <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><textarea type="text" className="text-textbox" rows="1" defaultValue={formData?.test_sitting_sys}></textarea></td>
                            <td style={{ padding: '5px' }}><textarea type="text" className="text-textbox" rows="1" defaultValue={formData?.test_sitting_dias}></textarea></td>
                          </tr>
                          <tr>
                            <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Second reading <small><i>(optional)</i></small></p></td>
                            <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><textarea type="text" className="text-textbox" rows="1" defaultValue={formData?.test_sitting_sys_2}></textarea></td>
                            <td style={{ padding: '5px' }}><textarea type="text" className="text-textbox" rows="1" defaultValue={formData?.test_sitting_dias_2}></textarea></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style={{  width: '60%' }}>
                      <div className="docpro_table_1 hipaa_table mb-1" style={{ boxShadow: 'none', borderRadius: 0 }}>
                        <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
                          <thead>
                            <tr>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph"><b style={{ color: "rgb(0 124 62)" }}>Urinalysis</b></p></td>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Sp. Gr</p></td>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Protein</p></td>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Blood</p></td>
                              <td style={{ padding: '5px' }}><p className="dot_phy_sm_paragraph">Sugar</p></td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><p className="dot_phy_sm_paragraph">Urinalysis is required. Numerical readings must be recorded.</p></td>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><textarea type="text" rows="2" className="text-textbox small" defaultValue={formData?.test_urin_sp}></textarea></td>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><textarea type="text" rows="2" className="text-textbox small" defaultValue={formData?.test_urin_protein}></textarea></td>
                              <td style={{ padding: '5px', borderRight: '1px solid var(--border)' }}><textarea type="text" rows="2" className="text-textbox small" defaultValue={formData?.test_urin_blood}></textarea></td>
                              <td style={{ padding: '5px' }}><textarea type="text" rows="2" className="text-textbox small" defaultValue={formData?.test_urin_sugar}></textarea></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <p className="pt-1 dot_phy_sm_paragraph"><i>Protein, blood, or sugar in the urine may be an indication for further testing to rule out any underlying medical problem</i></p>
                    </div>
                  </div>
                  <p className="mb-1 mt-2" style={{lineHeight: '14px'}}>
                    Other testing if indicated
                  </p>
                  <textarea className="dot_physical w-full p-2" rows="2" readOnly defaultValue={formData?.other_test}></textarea>
                  <div style={{ borderTop: '2px solid rgb(0 124 62)', marginBottom: '8px' }}></div>

                  <div className="flex">
                    <div className="mr-2" style={{ width: '50%' }}>
                      <p style={{fontSize: ".9rem", lineHeight: "1em", marginBottom: '4px'}}><b style={{ color: "rgb(0 124 62)" }}>Vision</b></p>
                      <p className="mb-1" style={{lineHeight: '14px'}}><small><i>Standard is at least 20/40 acuity (Snellen) in each eye with or without correction.
                                    At least 70° field of vision in horizontal meridian measured in each eye. The use of
                                    corrective lenses should be noted on the Medical Examiner’s Certificate.</i></small></p>

                      <table className="history-table mb-0">
                        <thead>
                          <tr>
                            <td><p><b>Acuity</b></p></td>
                            <td><p>Uncorrected</p></td>
                            <td><p>Corrected</p></td>
                            <td><p>Horizontal Field of Vision</p></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><p><small>Right Eye:</small></p></td>
                            <td><p><small>20/<input type="text" defaultValue={formData?.test_eye_1} style={{...customStyles.customInput, width: '50px'}}></input></small></p></td>
                            <td><p><small>20/<input type="text" defaultValue={formData?.test_eye_2} style={{...customStyles.customInput, width: '50px'}}></input></small></p></td>
                            <td><p><small>Right Eye:<input type="text" defaultValue={formData?.test_eye_3} style={{...customStyles.customInput, width: '50px'}}></input>degrees</small></p></td>
                          </tr>
                          <tr>
                            <td><p><small>Left Eye:</small></p></td>
                            <td><p><small>20/<input type="text" defaultValue={formData?.test_eye_4} style={{...customStyles.customInput, width: '50px'}}></input></small></p></td>
                            <td><p><small>20/<input type="text" defaultValue={formData?.test_eye_5} style={{...customStyles.customInput, width: '50px'}}></input></small></p></td>
                            <td><p><small>Left Eye:<input type="text" defaultValue={formData?.test_eye_6} style={{...customStyles.customInput, width: '50px'}}></input>degrees</small></p></td>
                          </tr>
                          <tr>
                            <td><p><small>Both Eyes:</small></p></td>
                            <td><p><small>20/<input type="text" defaultValue={formData?.test_eye_7} style={{...customStyles.customInput, width: '50px'}}></input></small></p></td>
                            <td><p><small>20/<input type="text" defaultValue={formData?.test_eye_8} style={{...customStyles.customInput, width: '50px'}}></input></small></p></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>

                      <table className="history-table mb-0">
                        <thead>
                          <tr>
                            <td></td>
                            <td><p className="text-center"><b>Yes</b></p></td>
                            <td><p className="text-center"><b>No</b></p></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><p>Applicant can recognize and distinguish among traffic control signals and devices showing red, green, and amber colors</p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_1 == 1} disabled /></p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_1 == 3} disabled /></p></td>
                          </tr>
                          <tr>
                            <td><p>Monocular vision</p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_2 == 1} disabled /></p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_2 == 3} disabled /></p></td>
                          </tr>
                          <tr>
                            <td><p>Referred to ophthalmologist or optometrist?</p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_3 == 1} disabled /></p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_3 == 3} disabled /></p></td>
                          </tr>
                          <tr>
                            <td><p>Received documentation from ophthalmologist or optometrist?</p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_4 == 1} disabled /></p></td>
                            <td><p className="text-center"><input type="radio" checked={formData?.test_vision_4 == 3} disabled /></p></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style={{ width: '50%' }}>
                      <p style={{fontSize: ".9rem", lineHeight: "1em", marginBottom: '4px'}}><b style={{ color: "rgb(0 124 62)" }}>Hearing</b></p>
                      <p style={{lineHeight: '14px'}}><small><i>Standard: Must first perceive whispered voice at not less than 5 feet <b>OR</b> average
                                    hearing loss of less than or equal to 40 dB, in better ear (with or without hearing aid).</i></small></p>
                      <p className="flex dot_phy_paragraph" style={{marginBottom: '4px', flexWrap: 'wrap'}}>
                        Check if hearing aid used for test:
                        <span className="inline-flex items-center pl-2">
                          <input type="checkbox" checked={formData?.test_hear_2 == 2} disabled></input>
                          <span className="px-2" style={{ lineHeight: '15px', whiteSpace: 'nowrap' }}>Right Ear</span>
                          <input type="checkbox" checked={formData?.test_hear_1 == 1} disabled></input>
                          <span className="px-2" style={{ lineHeight: '15px', whiteSpace: 'nowrap' }}>Left Ear</span>
                          <input type="checkbox" checked={formData?.test_hear_1 == 3} disabled></input>
                          <span className="px-2" style={{ lineHeight: '15px', whiteSpace: 'nowrap' }}>Neither</span>
                        </span>
                      </p>
                      <table className="history-table mb-0">
                        <thead>
                          <tr>
                            <td><p><b>Whisper Test Results</b></p></td>
                            <td><p>Right Ear</p></td>
                            <td><p>Left Ear</p></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><p>Record distance (in feet) from driver at which a forced whispered voice can first be heard</p></td>
                            <td><p><input type="text" defaultValue={formData?.test_hear_4} style={{...customStyles.customInput, width: '50px'}}></input></p></td>
                            <td><p><input type="text" defaultValue={formData?.test_hear_5} style={{...customStyles.customInput, width: '50px'}}></input></p></td>
                          </tr>
                        </tbody>
                      </table>
                      <p style={{fontSize: ".9rem", lineHeight: "1em", margin: '4px 0 6px 0'}}><b style={{ color: "rgb(0 124 62)" }}><i>Or</i></b></p>
                      <p style={{fontSize: ".9rem", lineHeight: "1em", marginBottom: '4px'}}><b>Audiometric Test Results</b></p>
                      <table className="history-table mb-0">
                        <thead>
                          <tr>
                            <td colSpan={3}><p>Right Ear</p></td>
                            <td colSpan={3}><p>Left Ear</p></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><p><small>500Hz/<input type="text" defaultValue={formData?.test_hear_6} style={{...customStyles.customInput, width: '45px'}}></input></small></p></td>
                            <td><p><small>1000Hz/<input type="text" defaultValue={formData?.test_hear_7} style={{...customStyles.customInput, width: '45px'}}></input></small></p></td>
                            <td><p><small>2000Hz/<input type="text" defaultValue={formData?.test_hear_8} style={{...customStyles.customInput, width: '45px'}}></input></small></p></td>
                            <td><p><small>500Hz/<input type="text" defaultValue={formData?.test_hear_9} style={{...customStyles.customInput, width: '45px'}}></input></small></p></td>
                            <td><p><small>1000Hz/<input type="text" defaultValue={formData?.test_hear_10} style={{...customStyles.customInput, width: '45px'}}></input></small></p></td>
                            <td><p><small>2000Hz/<input type="text" defaultValue={formData?.test_hear_11} style={{...customStyles.customInput, width: '45px'}}></input></small></p></td>
                          </tr>
                          <tr>
                            <td colSpan={3}><p><small>Average (right):<input type="text" defaultValue={formData?.test_hear_12} style={{...customStyles.customInput, width: '70px'}}></input></small></p></td>
                            <td colSpan={3}><p><small>Average (left):<input type="text" defaultValue={formData?.test_hear_13} style={{...customStyles.customInput, width: '70px'}}></input></small></p></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {formSize != 'A4' &&
                <div className="spacing_9"></div>
              }
              <div className="page_divider"></div>

              <div style={ customStyles.pageInfo }>
                <p className="dot_phy_paragraph">
                  Last Name: <input type="text" defaultValue={formData?.info_last_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  First Name: <input type="text" defaultValue={formData?.info_first_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  DOB: <input type="text" defaultValue={exchangeDate(formData?.info_dob)} readOnly style={{ ...customStyles.customInput, width: '95px' }}></input>
                  Exam Date: <input type="text" defaultValue={exchangeDate(formData?.heading_exam_date_1)} style={{ ...customStyles.customInput, width: '95px' }} readOnly></input>
                </p>
              </div>

              <div className="mb-2" style={customStyles.successDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(0 124 62)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>PHYSICAL EXAMINATION</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="dot_phy_semi_paragraph" style={{marginBottom: '10px'}}>
                    The presence of a certain condition may not necessarily disqualify a driver, particularly if the condition is controlled adequately, is not likely to
                    worsen, or is readily amenable to treatment. Even if a condition does not disqualify a driver, the Medical Examiner may consider deferring the driver
                    temporarily. Also, the driver should be advised to take the necessary steps to correct the condition as soon as possible, particularly if neglecting the
                    condition could result in a more serious illness that might affect driving.
                  </p>
                  <p className="dot_phy_semi_paragraph" style={{marginBottom: '10px'}}>
                    Check the body systems for abnormalities.
                  </p>

                  <table className="history-table mb-2">
                    <thead>
                      <tr>
                        <td><p><b>Body System</b></p></td>
                        <td><p className="text-center">Normal</p></td>
                        <td><p className="text-center">Abnormal</p></td>
                        <td><p><b>Body System</b></p></td>
                        <td><p className="text-center">Normal</p></td>
                        <td><p className="text-center">Abnormal</p></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><p className="flex"><span className="mr-1">1.</span> <span>General</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_1 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_1 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">8.</span> <span>Abdomen</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_8 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_8 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">2.</span> <span>Skin</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_2 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_2 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">9.</span> <span>Genito-urinary system including hernias</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_9 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_9 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">3.</span> <span>Eyes</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_3 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_3 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">10.</span> <span>Back/spine</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_10 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_10 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">4.</span> <span>Ears</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_4 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_4 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">11.</span> <span>Extremities/joints</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_11 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_11 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">5.</span> <span>Mouth/throat</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_5 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_5 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">12.</span> <span>Neurological system including reflexes</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_12 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_12 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">6.</span> <span>Cardiovascular</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_6 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_6 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">13.</span> <span>Gait</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_13 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_13 == 2} /></p></td>
                      </tr>
                      <tr>
                        <td><p className="flex"><span className="mr-1">7.</span> <span>Lungs/chest</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_7 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_7 == 2} /></p></td>
                        <td><p className="flex"><span className="mr-1">14.</span> <span>Vascular system</span></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_14 == 1} /></p></td>
                        <td><p className="text-center"><input type="radio" disabled checked={formData?.physical_14 == 2} /></p></td>
                      </tr>
                    </tbody>
                  </table>

                  <p className="mb-1" style={{lineHeight: '14px'}}>
                    <small style={{ fontSize: '90%' }}>
                    <i>Discuss any abnormal answers in detail in the space below and indicate whether it would affect the driver’s ability to operate a CMV. <br/>
                    Enter applicable item number before each comment.</i>
                    </small>
                  </p>
                  <textarea className="dot_physical w-full p-2" rows="6" readOnly defaultValue={formData?.physical_15}></textarea>
                  <p className="dot_phy_paragraph" style={{marginBottom: '5px', textAlign: 'end'}}><i>(Attach additional sheets if necessary)</i></p>
                  <div style={{ minHeight: '45px' }}>
                    {formData?.physical_sheet != null &&
                    <>
                      <p style={{fontSize: ".93rem", lineHeight: "1.3em", marginBottom: '5px'}}> Sheet: 
                        <span className="pl-2" style={{ color: '#3155a4' }}>{formData?.physical_sheet}</span>
                      </p>
                    </>
                    }
                  </div>
                </div>
              </div>

              {formSize == 'A4' ?
                <div className="spacing_11"></div>
              :
                <div className="spacing_12"></div>
              }
              <div className="page_divider"></div>

              <div style={ customStyles.pageInfo }>
                <p className="dot_phy_paragraph">
                  Last Name: <input type="text" defaultValue={formData?.info_last_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  First Name: <input type="text" defaultValue={formData?.info_first_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  DOB: <input type="text" defaultValue={exchangeDate(formData?.info_dob)} readOnly style={{ ...customStyles.customInput, width: '95px' }}></input>
                  Exam Date: <input type="text" defaultValue={exchangeDate(formData?.heading_exam_date_1)} style={{ ...customStyles.customInput, width: '95px' }} readOnly></input>
                </p>
              </div>

              <p style={{lineHeight: "1.4em", marginBottom: '10px'}}>
                <b style={{ color: '#cc1818' }}><i>Please complete only one of the following (Federal or State) Medical Examiner Determination sections:</i></b>
              </p>
              <div className="mb-2" style={customStyles.successDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(0 124 62)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>MEDICAL EXAMINER DETERMINATION (Federal)</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="dot_phy_semi_paragraph" style={{marginBottom: '10px', color: '#cc1818'}}>
                    <i>Use this section for examinations performed in accordance with the Federal Motor Carrier Safety Regulations (<a href="https://www.ecfr.gov/current/title-49/subtitle-B/chapter-III/subchapter-B/part-391#sp49.5.391.e" style={{ color: 'rgb(58 192 243)' }}> 49 CFR 391.41-391.49</a>):</i>
                  </p>
                  
                  <p className="dot_phy_paragraph">
                    <input type="radio" name="federal" checked={formData?.federal == 1} className="mr-2" disabled></input>
                    Does not meet standards <small><i> (specify reason)</i></small>:
                    <input type="text" checked={formData?.federal_1 == 1} style={{ ...customStyles.customInput, width: '350px' }} readOnly></input>
                  </p>

                  <p className="dot_phy_paragraph">
                    <input type="radio" checked={formData?.federal == 2} className="mr-2" disabled></input>
                    Meets standards in <small> <a href="https://www.fmcsa.dot.gov/regulations/title49/section/391.41" style={{color: "rgb(58 192 243)" }}> 49 CFR 391.41</a> </small>; qualifies for 2-year certificate
                  </p>
      
                  <div className="flex">
                    <p className="dot_phy_paragraph">
                      <input type="radio" checked={formData?.federal == 3} className="mr-2" disabled></input>
                    </p>
                    <div>
                      <p className="dot_phy_paragraph">Meets standards, but periodic monitoring required <small><i> (specify reason)</i></small>:
                        <input type="text" defaultValue={formData?.federal_2} style={customStyles.customInput} readOnly></input>
                      </p>
                      <p className="flex items-center dot_phy_paragraph">
                        <span className="mr-2">Driver qualified for:</span>
                        <input type="radio" checked={formData?.federal_3 == 1} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>3 months</span>
                        <input type="radio" checked={formData?.federal_3 == 2} className="pl-2 mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>6 months</span>
                        <input type="radio" checked={formData?.federal_3 == 3} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>1 year</span>
                        <input type="radio" checked={formData?.federal_3 == 4} className="mr-2" disabled></input>
                        <span>other <small><i>(specify):</i></small> 
                          <input type="text" defaultValue={formData?.federal_3_other} style={customStyles.customInput} readOnly></input>
                        </span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.federal_4 == 5} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Wearing corrective lenses</span>
                        <input type="checkbox" checked={formData?.federal_5 == 6} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Wearing hearing aid</span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.federal_6 == 7} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Accompanied by a waiver/exemption <small><i>(specify type)</i></small>: 
                          <input type="text" defaultValue={formData?.federal_6_other} readOnly style={{ ...customStyles.customInput, width: '92px' }}></input>
                        </span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.federal_7 == 8} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Accompanied by a Skill Performance Evaluation (SPE) Certificate</span>
                        <input type="checkbox" checked={formData?.federal_8 == 9} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Qualified by operation of 
                          <small>
                          <a href="https://www.ecfr.gov/current/title-49/subtitle-B/chapter-III/subchapter-B/part-391#391.64" style={{color: "rgb(58 192 243)" }}> 49 CFR 391.64 </a>
                          <i>(Federal)</i></small>
                        </span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.federal_9 == 10} className="mr-2" disabled></input>
                        <span style={{ lineHeight: '1.5em' }}>Driving within an exempt intracity zone <small><i>(see 
                          <a href="https://www.ecfr.gov/current/title-49/subtitle-B/chapter-III/subchapter-B/part-391#391.62" style={{color: "rgb(58 192 243)" }}> 49 CFR 391.62</a>
                        ) (Federal)</i></small></span>
                      </p>
                    </div>
                  </div>
                                        
                  <div className="flex">
                    <p className="dot_phy_paragraph">
                      <input type="radio" checked={formData?.federal == 4} className="mr-2" disabled></input>
                    </p>
                    <div className="mb-1">
                      <p className="dot_phy_paragraph">Determination pending <small><i> (specify reason)</i></small>:
                        <input type="text" defaultValue={formData?.federal_10} style={customStyles.customInput} readOnly></input>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.federal_11 == 11} className="mr-2" disabled></input>
                        <span>Return to medical exam office for follow-up on <small><i> (must be 45 days or less)</i></small>: 
                          <input type="text" readOnly defaultValue={formData?.federal_11_other} style={customStyles.customInput}></input>
                        </span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.federal_12 == 12} className="mr-2" disabled></input>
                        <span>Medical Examination Report amended <small><i> (specify reason)</i></small>: 
                          <input type="text" defaultValue={formData?.federal_12_other} readOnly style={customStyles.customInput}></input>
                        </span>
                      </p>
                      <p className="flex dot_phy_paragraph" style={{flexWrap: 'wrap'}}>
                        <small><i>(if amended)</i></small> Medical Examiner’s Signature: 
                        <input type="text" defaultValue={formData?.federal_13} readOnly style={customStyles.customInput}></input>
                        Date: 
                        <input type="text" defaultValue={exchangeDate(formData?.federal_14)} style={customStyles.customInput} minLength="10" maxLength="10" readOnly></input>
                      </p>
                    </div>
                  </div>

                  <p className="dot_phy_paragraph">
                    <input type="radio" checked={formData?.federal == 5} className="mr-2" disabled></input>
                    Incomplete examination <small><i> (specify reason)</i></small>:
                    <input type="text" defaultValue={formData?.federal_15} style={{ ...customStyles.customInput, width: '350px' }} readOnly></input>
                  </p>
                  
                  <p style={{...customStyles.pageInfo, fontSize: ".93rem", lineHeight: "1.3em", marginTop: '6px' }}>
                    <b>If the driver meets the standards outlined in 
                      <a href="https://www.fmcsa.dot.gov/regulations/title49/section/391.41" style={{color: "rgb(58 192 243)"}}> 49 CFR 391.41</a>
                      , then complete a Medical Examiner’s Certificate as stated in 
                      <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&amp;ty=HTML&amp;h=L&amp;mc=true&amp;=PART&amp;n=pt49.5.391" style={{color: "rgb(58 192 243)" }}> 49 CFR 391.43(h)</a>
                      , as appropriate.
                    </b>
                  </p>
                  
                  <p style={{fontSize: ".93rem", lineHeight: "1.3em" }}>
                    I have performed this evaluation for certification. I have
                    personally reviewed all available records and recorded information pertaining to this
                    evaluation, and attest that, to the best of my knowledge, I believe it to be true and correct.
                  </p>
                  
                  <p className="dot_phy_paragraph" style={{marginBottom: '10px'}}>
                    Medical Examiner’s Signature: 
                    <input type="text" defaultValue={formData?.federal_16} readOnly style={{...customStyles.customInput, width: '350px'}}></input> <br></br>
                    Medical Examiner’s Name <small><i> (please print or type)</i></small>: 
                    <input type="text" defaultValue={formData?.federal_17} style={{...customStyles.customInput, width: '350px'}} readOnly></input>
                    Medical Examiner’s Address: 
                    <input type="text" defaultValue={formData?.federal_18} style={customStyles.customInput} readOnly></input>
                    City: 
                    <input type="text" defaultValue={formData?.federal_19} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                    State: 
                    <select value={formData?.federal_20} style={{ ...customStyles.customInput, width: '62px' }} disabled>
                      <option value="AK">AK</option>
                      <option value="AL">AL</option>
                      <option value="AR">AR</option>
                      <option value="AZ">AZ</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DC">DC</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="IA">IA</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="MA">MA</option>
                      <option value="ME">ME</option>
                      <option value="MI">MI</option>
                      <option value="MO">MO</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="NE">NE</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NV">NV</option>
                      <option value="NY">NY</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VA">VA</option>
                      <option value="VT">VT</option>
                      <option value="WA">WA</option>
                      <option value="WI">WI</option>
                      <option value="WV">WV</option>
                      <option value="WY">WY</option>
                      <option value="AB">AB</option>
                      <option value="BC">BC</option>
                      <option value="MB">MB</option>
                      <option value="NB">NB</option>
                      <option value="NL">NL</option>
                      <option value="NS">NS</option>
                      <option value="NT">NT</option>
                      <option value="NU">NU</option>
                      <option value="ON">ON</option>
                      <option value="PE">PE</option>
                      <option value="QC">QC</option>
                      <option value="SK">SK</option>
                      <option value="YT">YT</option>
                    </select>
                    Zip Code: 
                    <input type="text" defaultValue={formData?.federal_21} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                    Medical Examiner’s Telephone Number: 
                    <input type="text" defaultValue={formData?.federal_22} style={customStyles.customInput} minLength="10" maxLength="10" readOnly></input>
                    Date Certificate Signed: 
                    <input type="text" defaultValue={formData?.federal_23} style={customStyles.customInput} minLength="10" maxLength="10" readOnly></input>
                    Medical Examiner’s State License, Certificate, or Registration Number: 
                    <input type="text" defaultValue={formData?.federal_24} style={customStyles.customInput} readOnly></input> <br />
                    Issuing State: 
                    <select value={formData?.federal_25} style={{ ...customStyles.customInput, width: '62px' }} disabled>
                      <option value="AK">AK</option>
                      <option value="AL">AL</option>
                      <option value="AR">AR</option>
                      <option value="AZ">AZ</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DC">DC</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="IA">IA</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="MA">MA</option>
                      <option value="ME">ME</option>
                      <option value="MI">MI</option>
                      <option value="MO">MO</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="NE">NE</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NV">NV</option>
                      <option value="NY">NY</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VA">VA</option>
                      <option value="VT">VT</option>
                      <option value="WA">WA</option>
                      <option value="WI">WI</option>
                      <option value="WV">WV</option>
                      <option value="WY">WY</option>
                      <option value="AB">AB</option>
                      <option value="BC">BC</option>
                      <option value="MB">MB</option>
                      <option value="NB">NB</option>
                      <option value="NL">NL</option>
                      <option value="NS">NS</option>
                      <option value="NT">NT</option>
                      <option value="NU">NU</option>
                      <option value="ON">ON</option>
                      <option value="PE">PE</option>
                      <option value="QC">QC</option>
                      <option value="SK">SK</option>
                      <option value="YT">YT</option>
                    </select>
                  </p>
                  <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '10px'}}>
                    <input type="checkbox" checked={formData?.federal_26 == 1} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>MD</span>
                    <input type="checkbox" checked={formData?.federal_27 == 2} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>DO</span>
                    <input type="checkbox" checked={formData?.federal_28 == 3} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Physician Assistant</span>
                    <input type="checkbox" checked={formData?.federal_29 == 4} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Chiropractor</span>
                    <input type="checkbox" checked={formData?.federal_30 == 5} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Advanced Practice Nurse</span>
                  </p>
                  <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '10px'}}>
                    <input type="checkbox" checked={formData?.federal_31 == 6} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Other Practitioner <small><i>(specify):</i></small></span>
                    <input type="text" defaultValue={formData?.federal_31_other} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                  </p>
                                                            
                  <div className="flex justify-between" style={{ marginTop: '12px' }}>
                    <p className="dot_phy_paragraph">
                      National Registry Number: <input type="text" defaultValue={formData?.federal_32} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                    </p>
                    <div className="second-page" style={ customStyles.pageInfo }>
                      <p style={{fontSize: ".93rem" }} className="mb-0">Medical Examiner’s Certificate Expiration Date: 
                        <input type="text" defaultValue={exchangeDate(formData?.federal_33)} style={{...customStyles.customInput, width: '100px' }} minLength="10" maxLength="10" readOnly></input>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {formSize == 'A4' ?
                <div className="spacing_2"></div>
              :
                <div className="spacing_16"></div>
              }
              <div className="page_divider"></div>

              <div style={ customStyles.pageInfo }>
                <p className="dot_phy_paragraph">
                  Last Name: <input type="text" defaultValue={formData?.info_last_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  First Name: <input type="text" defaultValue={formData?.info_first_name} readOnly style={{...customStyles.customInput, width: '120px'}}></input>
                  DOB: <input type="text" defaultValue={exchangeDate(formData?.info_dob)} readOnly style={{ ...customStyles.customInput, width: '95px' }}></input>
                  Exam Date: <input type="text" defaultValue={exchangeDate(formData?.heading_exam_date_1)} style={{ ...customStyles.customInput, width: '95px' }} readOnly></input>
                </p>
              </div>

              <div className="mb-2" style={customStyles.successDiv}>
                <p className="dot_phy_semi_paragraph" style={{background: "rgb(0 124 62)", padding: "5px 8px"}}><b style={{ color: "#ffffff" }}>MEDICAL EXAMINER DETERMINATION (State)</b></p>
                <div style={{ padding: '8px' }}>
                  <p className="dot_phy_semi_paragraph" style={{marginBottom: '10px', color: '#cc1818'}}>
                    <i>Use this section for examinations performed in accordance with the Federal Motor Carrier Safety Regulations (<a href="http://www.ecfr.gov/cgi-bin/retrieveECFR?gp=&SID=39a65387939385e39223dab3dcdda350&n=pt49.5.391&r=PART&ty=HTML#sp49.5.391.e" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41-391.49</a>) with any applicable State variances (which will only be valid for intrastate operations):</i>
                  </p>
                  
                  <p className="dot_phy_paragraph">
                    <input type="radio" checked={formData?.m_state == 1} className="mr-2" disabled></input>
                    Does not meet standards in <a href="https://www.fmcsa.dot.gov/regulations/title49/section/391.41" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a>, with any applicable State variances <small><i> (specify reason)</i></small>:
                    <input type="text" defaultValue={formData?.m_state_1} style={{ ...customStyles.customInput, width: '150px' }} readOnly></input>
                  </p>

                  <p className="dot_phy_paragraph">
                    <input type="radio" checked={formData?.m_state == 2} className="mr-2" disabled></input>
                    Meets standards in <small><a href="https://www.fmcsa.dot.gov/regulations/title49/section/391.41" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a></small>; qualifies for 2-year certificate
                  </p>
      
                  <div className="flex">
                    <p className="dot_phy_paragraph">
                      <input type="radio" checked={formData?.m_state == 3} className="mr-2" disabled></input>
                    </p>
                    <div>
                      <p className="dot_phy_paragraph">Meets standards, but periodic monitoring required <small><i> (specify reason)</i></small>:
                        <input type="text" defaultValue={formData?.m_state_2} style={customStyles.customInput} readOnly></input>
                      </p>
                      <p className="flex items-center mb-0 dot_phy_paragraph">
                        <span className="mr-2">Driver qualified for:</span>
                        <input type="radio" checked={formData?.m_state_3 == 1} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>3 months</span>
                        <input type="radio" checked={formData?.m_state_3 == 2} className="pl-2 mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>6 months</span>
                        <input type="radio" checked={formData?.m_state_3 == 3} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>1 year</span>
                        <input type="radio" checked={formData?.m_state_3 == 4} className="mr-2" disabled></input>
                        <span>other <small><i>(specify):</i></small> 
                          <input type="text" defaultValue={formData?.m_state_3_other} style={customStyles.customInput} readOnly></input>
                        </span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.m_state_4 == 5} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Wearing corrective lenses</span>
                        <input type="checkbox" checked={formData?.m_state_5 == 6} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Wearing hearing aid</span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.m_state_6 == 7} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Accompanied by a waiver/exemption <small><i>(specify type)</i></small>: 
                          <input type="text" defaultValue={formData?.m_state_6_other} readOnly style={{ ...customStyles.customInput, width: '92px' }}></input>
                        </span>
                      </p>
                      <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '6px', flexWrap: 'wrap'}}>
                        <input type="checkbox" checked={formData?.m_state_7 == 8} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Accompanied by a Skill Performance Evaluation (SPE) Certificate</span>
                        <input type="checkbox" checked={formData?.m_state_8 == 9} className="mr-2" disabled></input>
                        <span className="mr-2" style={{ lineHeight: '1.5em' }}>Grandfathered from State requirements <small><i>(State)</i></small></span>
                      </p>
                    </div>
                  </div>
                  
                  <p style={{...customStyles.pageInfo, fontSize: ".93rem", lineHeight: "1.3em", marginTop: '6px' }}>
                    <b>If the driver meets the standards outlined in 
                      <a href="https://www.fmcsa.dot.gov/regulations/title49/section/391.41" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a>
                      , with applicable State variances, then complete a Medical Examiner’s Certificate, as appropriate.
                    </b>
                  </p>
                  
                  <p style={{fontSize: ".93rem", lineHeight: "1.3em" }}>
                    I have performed this evaluation for certification. I have personally reviewed all available records and recorded information pertaining to this
                    evaluation, and attest that, to the best of my knowledge, I believe it to be true and correct
                  </p>
                  
                  <p className="dot_phy_paragraph" style={{marginBottom: '10px'}}>
                    Medical Examiner’s Signature: 
                    <input type="text" readOnly defaultValue={formData?.m_state_9} style={{...customStyles.customInput, width: '350px'}}></input> <br></br>
                    Medical Examiner’s Name <small><i> (please print or type)</i></small>: 
                    <input type="text" defaultValue={formData?.m_state_10} style={{...customStyles.customInput, width: '350px'}} readOnly></input>
                    Medical Examiner’s Address: 
                    <input type="text" defaultValue={formData?.m_state_11} style={customStyles.customInput} readOnly></input>
                    City: 
                    <input type="text" defaultValue={formData?.m_state_12} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                    State: 
                    <select value={formData?.m_state_13} style={{ ...customStyles.customInput, width: '62px' }} disabled>
                      <option value="AK">AK</option>
                      <option value="AL">AL</option>
                      <option value="AR">AR</option>
                      <option value="AZ">AZ</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DC">DC</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="IA">IA</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="MA">MA</option>
                      <option value="ME">ME</option>
                      <option value="MI">MI</option>
                      <option value="MO">MO</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="NE">NE</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NV">NV</option>
                      <option value="NY">NY</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VA">VA</option>
                      <option value="VT">VT</option>
                      <option value="WA">WA</option>
                      <option value="WI">WI</option>
                      <option value="WV">WV</option>
                      <option value="WY">WY</option>
                      <option value="AB">AB</option>
                      <option value="BC">BC</option>
                      <option value="MB">MB</option>
                      <option value="NB">NB</option>
                      <option value="NL">NL</option>
                      <option value="NS">NS</option>
                      <option value="NT">NT</option>
                      <option value="NU">NU</option>
                      <option value="ON">ON</option>
                      <option value="PE">PE</option>
                      <option value="QC">QC</option>
                      <option value="SK">SK</option>
                      <option value="YT">YT</option>
                    </select>
                    Zip Code: 
                    <input type="text" defaultValue={formData?.m_state_14} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                    Medical Examiner’s Telephone Number: 
                    <input type="text" defaultValue={formData?.m_state_15} style={customStyles.customInput} minLength="10" maxLength="10" readOnly></input>
                    Date Certificate Signed: 
                    <input type="text" defaultValue={formData?.m_state_16} style={customStyles.customInput} minLength="10" maxLength="10" readOnly></input>
                    Medical Examiner’s State License, Certificate, or Registration Number: 
                    <input type="text" defaultValue={formData?.m_state_17} style={customStyles.customInput} readOnly></input> <br />
                    Issuing State: 
                    <select value={formData?.m_state_13} style={{ ...customStyles.customInput, width: '62px' }} disabled>
                      <option value="AK">AK</option>
                      <option value="AL">AL</option>
                      <option value="AR">AR</option>
                      <option value="AZ">AZ</option>
                      <option value="CA">CA</option>
                      <option value="CO">CO</option>
                      <option value="CT">CT</option>
                      <option value="DC">DC</option>
                      <option value="DE">DE</option>
                      <option value="FL">FL</option>
                      <option value="GA">GA</option>
                      <option value="HI">HI</option>
                      <option value="IA">IA</option>
                      <option value="ID">ID</option>
                      <option value="IL">IL</option>
                      <option value="IN">IN</option>
                      <option value="KS">KS</option>
                      <option value="KY">KY</option>
                      <option value="LA">LA</option>
                      <option value="MA">MA</option>
                      <option value="ME">ME</option>
                      <option value="MI">MI</option>
                      <option value="MO">MO</option>
                      <option value="MN">MN</option>
                      <option value="MS">MS</option>
                      <option value="MT">MT</option>
                      <option value="NC">NC</option>
                      <option value="ND">ND</option>
                      <option value="NE">NE</option>
                      <option value="NH">NH</option>
                      <option value="NJ">NJ</option>
                      <option value="NM">NM</option>
                      <option value="NV">NV</option>
                      <option value="NY">NY</option>
                      <option value="OH">OH</option>
                      <option value="OK">OK</option>
                      <option value="OR">OR</option>
                      <option value="PA">PA</option>
                      <option value="RI">RI</option>
                      <option value="SC">SC</option>
                      <option value="SD">SD</option>
                      <option value="TN">TN</option>
                      <option value="TX">TX</option>
                      <option value="UT">UT</option>
                      <option value="VA">VA</option>
                      <option value="VT">VT</option>
                      <option value="WA">WA</option>
                      <option value="WI">WI</option>
                      <option value="WV">WV</option>
                      <option value="WY">WY</option>
                      <option value="AB">AB</option>
                      <option value="BC">BC</option>
                      <option value="MB">MB</option>
                      <option value="NB">NB</option>
                      <option value="NL">NL</option>
                      <option value="NS">NS</option>
                      <option value="NT">NT</option>
                      <option value="NU">NU</option>
                      <option value="ON">ON</option>
                      <option value="PE">PE</option>
                      <option value="QC">QC</option>
                      <option value="SK">SK</option>
                      <option value="YT">YT</option>
                    </select>
                  </p>
                  <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '10px'}}>
                    <input type="checkbox" checked={formData?.m_state_19 == 1} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>MD</span>
                    <input type="checkbox" checked={formData?.m_state_20 == 2} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>DO</span>
                    <input type="checkbox" checked={formData?.m_state_21 == 3} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Physician Assistant</span>
                    <input type="checkbox" checked={formData?.m_state_22 == 4} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Chiropractor</span>
                    <input type="checkbox" checked={formData?.m_state_23 == 5} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Advanced Practice Nurse</span>
                  </p>
                  <p className="flex items-center dot_phy_paragraph" style={{marginBottom: '10px'}}>
                    <input type="checkbox" checked={formData?.m_state_24 == 6} className="mr-2" disabled></input>
                    <span className="mr-2" style={{ lineHeight: '1.5em' }}>Other Practitioner <small><i>(specify):</i></small></span>
                    <input type="text" defaultValue={formData?.m_state_24_other} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                  </p>
                                                            
                  <div className="flex justify-between" style={{ marginTop: '12px' }}>
                    <p className="dot_phy_paragraph">
                      National Registry Number: <input type="text" defaultValue={formData?.m_state_25} style={{...customStyles.customInput, width: '100px' }} readOnly></input>
                    </p>
                    <div className="second-page" style={ customStyles.pageInfo }>
                      <p style={{fontSize: ".93rem" }} className="mb-0">Medical Examiner’s Certificate Expiration Date: 
                        <input type="text" defaultValue={exchangeDate(formData?.m_state_26)} style={{...customStyles.customInput, width: '100px' }} minLength="10" maxLength="10" readOnly></input>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {formSize == 'A4' ?
                <div className="spacing_18"></div>
              :
                <>
                <div className="spacing_5"></div>
                <div className="spacing_16"></div></>
              }
              <div className="page_divider"></div>

              <div className="dot_phy_description">
                <h5>Instructions for Completing the Medical Examination Report Form (MCSA-5875)</h5>
                <div className="flex">
                  <h5 style={{ paddingRight: '10px', margin: 0 }}><b>i. </b></h5>
                  <div>
                    <h6 style={{ margin: 0 }}><b>Step-By-Step Instructions</b></h6>
                    <h6 style={{ margin: '8px 0' }}><b>Driver:</b></h6>
    
                    <div style={{ marginLeft: '15px' }}>
                      <h6 style={{ margin: '8px 0' }}><b>Section 1: Driver Information</b></h6>
  
                      <ul className="mb-2">
                        <li>
                          <p style={{marginBottom: '8px'}}><b>Personal
                            Information:</b> Please complete this section using your name as written on your
                            driver’s license,
                            your current address and phone number, your date of birth, age, driver’s license number
                            and issuing state.
                          </p>
                          <ul className="mb-2">
                            <li>
                              <p style={{marginBottom: '8px'}}><b>CLP/CDL
                                Applicant/Holder:</b> Check “yes” if you are a commercial learner’s permit
                                <b>(CLP)</b> or commercial
                                driver’s license <b>(CDL)</b> holder, or are applying for a CLP or CDL. CDL
                                means a license issued by a State
                                or the District of Columbia which authorizes the individual to operate a class
                                of a commercial motor
                                vehicle <b>(CMV)</b>. A CMV that requires a CDL is one that: (1) has a gross
                                combination weight rating or
                                gross combination weight of 26,001 pounds or more inclusive of a towed unit with
                                a gross vehicle
                                weight rating <b>(GVWR)</b> or gross vehicle weight <b>(GVW)</b> of more than
                                10,000 pounds; or (2) has a GVWR
                                or GVW of 26,001 pounds or more; or (3) is designed to transport 16 or more
                                passengers, including
                                the driver; or (4) is used to transport either hazardous materials requiring
                                hazardous materials
                                placards on the vehicle or any quantity of a select agent or toxin.
                              </p>
                            </li>
                            <li>
                              <p style={{marginBottom: '8px'}}><b>Driver ID
                                Verified By:</b> The Medical Examiner/staff completes this item and notes
                                the type of photo ID
                                used to verify the driver’s identity such as, commercial driver’s license,
                                driver’s license, or passport, etc.
                              </p>
                            </li>
                            <li>
                              <p style={{margin: 0}}><b>Has your
                              USDOT/FMCSA medical certificate ever been denied or issued for less than two
                              years?</b>
                              Please check the correct box “yes” or “no” and if you aren’t sure check the “not sure” box.</p>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p style={{marginBottom: '8px'}}><b>Driver Health History:</b></p>
                          <ul className="mb-2">
                            <li>
                              <p style={{marginBottom: '8px'}}><b>Have you ever
                              had surgery:</b> Please check “yes” if you have ever had surgery and provide
                              a written
                              explanation of the details (type of surgery, date of surgery, etc.)</p>
                            </li>
                            <li>
                              <p style={{marginBottom: '8px'}}><b>Are you
                                currently taking medications (prescription, over-the-counter, herbal
                                remedies, diet
                                supplements):</b> Please check “yes” if you are taking any diet supplements,
                                herbal remedies, or
                                prescription or over the counter medications. In the box below the question,
                                indicate the name of
                                the medication and the dosage.</p>
                            </li>
                            <li>
                              <p style={{marginBottom: '8px'}}><b>#1-32:</b>
                              Please complete this section by checking the “yes” box to indicate that you
                              have, or have ever
                              had, the health condition listed or the “No” box if you have not. Check the “not
                              sure” box if you are unsure.</p>
                            </li>
                            <li>
                              <p style={{marginBottom: '8px'}}><b>Other Health
                              Conditions not described above:</b> If you have, or have had, any other
                              health conditions not listed in the section above, check “Yes” and in the box
                              provided and list those condition(s).</p>
                            </li>
                            <li>
                              <p style={{margin: 0}}><b>Any yes answers
                              to questions #1-32 above:</b> If you have answered “yes” to any of the
                              questions in the
                              Driver Health History section above, please explain your answers further in the
                              box below the
                              question. For example, if you answered “yes” to question #5 regarding heart
                              disease, heart attack,
                              bypass, or other heart problem, indicate which type of heart condition. If you
                              checked “yes” to
                              question #23 regarding cancer, indicate the type of cancer. Please add any
                              information that will be
                              helpful to the Medical Examiner.</p>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p style={{marginBottom: '8px'}}><b>CMV Driver Signature and Date:</b> Please read the certification statement, sign and date it, indicating
                          that the information you provided in Section 1 is accurate and complete.</p>
                        </li>
                      </ul>
                    </div>

                    <h6 style={{ margin: 0 }}><b>Medical Examiner:</b></h6>
                    <div style={{ marginLeft: '15px' }}>
                      <h6 style={{ margin: '8px 0' }}><b>Section 2: Examination Report</b></h6>
                    </div>
                  </div>
                </div>
              </div>

              <div className="dot_phy_description">
                <div style={{ marginLeft: '15px' }}>
                  <div style={{ marginLeft: '15px' }}>
                    <ul className="mb-2">
                      <li>
                        <p style={{marginBottom: '8px'}}><b>Driver Health History Review:</b> 
                          Review answers provided by the driver in the driver health history section
                          and discuss any “yes” and “not sure” responses. In addition, be sure to compare the medication list to the
                          health history responses ensuring that the medication list matches the medical conditions noted. Explore
                          with the driver any answers that seem unclear. Record any information that the driver omitted. As the
                          Medical Examiner conducting the driver’s physical examination you are required to complete the entire
                          medical examination even if you detect a medical condition that you consider disqualifying, such as
                          deafness. Medical Examiners are expected to determine the driver’s physical qualification for operating
                          a commercial vehicle safely. Thus, if you find a disqualifying condition for which a driver may receive a
                          Federal Motor Carrier Safety Administration medical exemption, please record that on the driver’s Medical
                          Examiner’s Certificate, Form MCSA-5876, as well as on the Medical Examination Report Form, MCSA-5875.
                        </p>
                      </li>
                      <li>
                        <p style={{marginBottom: '8px'}}><b>Testing:</b></p>
                        <ul className="mb-2">
                          <li>
                            <p style={{marginBottom: '8px'}}><b>Pulse rate and rhythm, height, and weight:</b> record these as indicated on the form.</p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}><b>Blood Pressure:</b> record the blood pressure (systolic and diastolic) of the driver being examined. A
                            second reading is optional and should be recorded if found to be necessary.</p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}><b>Urinalysis:</b> record the numerical readings for the specific gravity, protein, blood and sugar.</p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}><b>Vision:</b> The current vision standard is provided on the form. When other than the Snellen chart is
                            used, give test results in Snellen-comparable values. When recording distance vision, use 20 feet
                            as normal. Record the vision acuity results and indicate if the driver can recognize and distinguish
                            among traffic control signals and devices showing red, green, and amber colors; has monocular
                            vision; has been referred to an ophthalmologist or optometrist; and if documentation has been
                            received from an ophthalmologist or optometrist.</p>
                          </li>
                          <li>
                            <p style={{ margin: 0}}><b>Hearing:</b> The current hearing standard is provided on the form. Hearing can be tested using either a
                            whisper test or audiometric test. Record the test results in the corresponding section for the test used.</p>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <p style={{ margin: 0}}><b>Physical Examination:</b> Check the body systems for abnormalities and indicate normal or abnormal
                        for each body system listed. Discuss any abnormal answers in detail in the space provided and indicate
                        whether it would affect the driver’s ability to safely operate a commercial motor vehicle.</p>
                      </li>
                    </ul>
  
                    <p style={{marginBottom: '8px'}}><b style={{ color: 'rgb(204 24 24)' }}>In this next section, you will be completing either the Federal or State determination, not both.</b></p>
                    <ul className="mb-2">
                      <li>
                        <p style={{marginBottom: '8px'}}><b>Medical Examiner Determination (Federal):</b> Use this section for examinations performed in
                          accordance with the FMCSRs (<a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=e4c7bad7a48c74d8f794df62ee78763b&node=sp49.5.391.e&rgn=div6" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41-391.49</a>). Complete the medical examiner determination
                          section completely. When determining a driver’s physical qualification, please note that English language
                          proficiency (<a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.391#se49.5.391_111" style={{ color: 'rgb(58 192 243)' }}>49 CFR part 391.11</a>: General qualifications of drivers) is not factored into that determination.
                        </p>
                        <ul className="mb-2">
                          <li>
                            <p style={{marginBottom: '8px'}}><b>Does not meet standards:</b> Select this option when a driver is determined to be not qualified and
                            provide an explanation of why the driver does not meet the standards in <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.391#se49.5.391_141" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a>.</p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}><b>Meets standards in <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.391#se49.5.391_141" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a>; qualifies for 2-year certification:</b> Select this option when a
                            driver is determined to be qualified and will be issued a 2-year Medical Examiner’s Certificate.</p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Meets standards, but periodic monitoring is required:</b> Select this option
                              when a driver is
                              determined to be qualified but needs periodic monitoring and provide an
                              explanation of why
                              periodic monitoring is required. Select the corresponding time frame that the
                              driver is qualified for,
                              and if selecting “other” specify the time frame.
                            </p>
                            <div className="flex">
                              <div style={{ margin: '8px 8px 0 0', borderTop: '1px solid #000000', paddingRight: '15px' }}></div>
                              <p style={{margin: 0}}>
                                <b>Determination that driver meets standards:</b> Select all categories that
                                apply to the driver’s
                                certification (e.g., wearing corrective lenses, accompanied by a
                                waiver/exemption, driving within
                                an exempt intracity zone, etc.).
                              </p>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="dot_phy_description">
                <div style={{ marginLeft: '15px' }}>
                  <div style={{ marginLeft: '15px' }}>
                    <ul className="mb-2">
                      <li style={{ listStyle: 'none' }}>
                        <ul className="mb-2">
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Determination pending:</b> Select this option when more information is needed to make a qualification
                              decision and specify a date, on or before the 45 day expiration date, for the driver to return to the
                              medical exam office for follow-up. This will allow for a delay of the qualification decision for as many
                              as 45 days. If the disposition of the pending examination is not updated via the National Registry on or
                              before the 45 day expiration date, FMCSA will notify the examining medical examiner and the driver in
                              writing that the examination is no longer valid and that the driver is required to be re-examined.
                            </p>
                            <div className="flex">
                              <div style={{ margin: '8px 8px 0 0', borderTop: '1px solid #000000', paddingRight: '15px' }}></div>
                              <p style={{marginBottom: '8px'}}>
                                <b>MER amended:</b> A Medical Examination Report Form (MER), MCSA-5875, may only be amended
                                while in determination pending status for situations where new information (e.g., test results,
                                etc.) has been received or there has been a change in the driver’s medical status since the initial
                                examination, but prior to a final qualification determination. Select this option when a Medical
                                Examination Report Form, MCSA-5875, is being amended; provide the reason for the amendment,
                                sign and date. In addition, initial and date any changes made on the Medical Examination Report
                                Form, MCSA-5875. A Medical Examination Report Form, MCSA-5875, cannot be amended after
                                an examination has been in determination pending status for more than 45 days or after a final
                                qualification determination has been made. The driver is required to obtain a new physical
                                examination and a new Medical Examination Report Form, MCSA-5875, should be completed.
                              </p>
                            </div>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Incomplete examination:</b> Select this when the physical examination is not completed for any
                              reason (e.g., driver decides they do not want to continue with the examination and leaves) other than
                              situations outlined under determination pending.
                            </p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Medical Examiner information, signature and date:</b> Provide your name, address, phone number,
                              occupation, license, certificate, or registration number and issuing state, national registry number,
                              signature and date.
                            </p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Medical Examiner’s Certificate Expiration Date:</b> Enter the date the <b>driver’s</b> Medical Examiner’s
                              Certificate (MEC) expires.
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul className="mb-2">
                      <li>
                        <p style={{marginBottom: '8px'}}>
                          <b>Medical Examiner Determination (State):</b> Use this section for examinations performed in accordance
                          with the FMCSRs (<a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=e4c7bad7a48c74d8f794df62ee78763b&node=sp49.5.391.e&rgn=div6" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41-391.49</a>) with any applicable State variances (which will only be valid for
                          intrastate operations). Complete the medical examiner determination section completely.
                        </p>
                        <ul className="mb-2">
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Does not meet standards in <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.391#se49.5.391_141" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a> with any applicable State variances:</b> Select this
                              option when a driver is determined to be not qualified and provide an explanation of why the driver
                              does not meet the standards in <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.391#se49.5.391_141" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a> with any applicable State variances
                            </p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Meets standards in <a href="https://www.ecfr.gov/cgi-bin/retrieveECFR?gp=1&ty=HTML&h=L&mc=true&=PART&n=pt49.5.391#se49.5.391_141" style={{ color: 'rgb(58 192 243)' }}>49 CFR 391.41</a> with any applicable State variances:</b> Select this option when a
                              driver is determined to be qualified and will be issued a 2-year Medical Examiner’s Certificate.
                            </p>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Meets standards, but periodic monitoring is required:</b> Select this option when a driver is determined to be qualified but needs periodic monitoring and provide an explanation of why periodic
                              monitoring is required. Select the corresponding time frame that the driver is qualified for, and if
                              selecting “other” specify the time frame.
                            </p>
                            <div className="flex">
                              <div style={{ margin: '8px 8px 0 0', borderTop: '1px solid #000000', paddingRight: '15px' }}></div>
                              <p style={{marginBottom: '8px'}}>
                                <b>Determination that driver meets standards:</b> Select all categories that apply to the driver’s
                                certification (e.g., wearing corrective lenses, accompanied by a waiver/exemption, etc.).
                              </p>
                            </div>
                          </li>
                          <li>
                            <p style={{marginBottom: '8px'}}>
                              <b>Medical Examiner information, signature and date:</b> Provide your name, address, phone number,
                              occupation, license, certificate, or registration number and issuing state, national registry number,
                              signature and date.
                            </p>
                          </li>
                          <li>
                            <p style={{margin: 0}}>
                              <b>Medical Examiner’s Certificate Expiration Date:</b> Enter the date the <b>driver’s</b> Medical Examiner’s
                              Certificate (MEC) expires.
                            </p>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex mb-2">
                  <h5 style={{ paddingRight: '10px', margin: 0 }}><b>ii. </b></h5>
                  <p style={{ margin: 0 }}><b>If updating an existing exam, you must resubmit the new exam results, via the Medical Examination
                  Results Form, MCSA-5850, to the National Registry, and the most recent dated exam will take precedence.</b></p>
                </div>

                <div className="flex">
                  <h5 style={{ paddingRight: '10px', margin: 0 }}><b>iii. </b></h5>
                  <p style={{ margin: 0 }}><b>To obtain additional information regarding this form go to the Medical Program’s page on the Federal
                  Motor Carrier Safety Administration’s website at <a href="http://www.fmcsa.dot.gov/regulations/medical" style={{ color: 'rgb(58 192 243)' }}>http://www.fmcsa.dot.gov/regulations/medical</a>.</b></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="docpro_invoice_btns docpro_hide_print">
        <button
          className="docpro_invoice_btn docpro_color3 close_button"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handleCloseWindow();
            } else {
              setFormView();
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </span>
          <span className="docpro_btn_text">Close</span>
        </button>

        <button
          className="docpro_invoice_btn docpro_color1"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handlePrint();
            } else {
              handleFormPrint(formViewId);
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
              <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
              <rect x={128} y={240} width={256} height={208} rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <circle cx={392} cy={184} r={24} fill="currentColor" /> 
            </svg>
          </span>
          <span className="docpro_btn_text">Print</span>
        </button>
      </div>
    </div>
  );
}
